import { getReports } from "@/services/reports.service";
import { useQueries } from "@tanstack/react-query";

// There's no dedicated /reports/stats endpoint yet, so this pieces the
// summary tiles together from the list endpoint (size=1 requests, we only
// need each response's totalCount) plus one sorted-by-generatedOn request
// for "last generated". Ask backend for a real stats endpoint to replace this.
export const useReportStats = () => {
  const results = useQueries({
    queries: [
      {
        queryKey: ["reportStats", "total"],
        queryFn: () => getReports({ page: 0, size: 1 }),
      },
      {
        queryKey: ["reportStats", "awaitingApproval"],
        queryFn: () =>
          getReports({ page: 0, size: 1, status: "AWAITING_APPROVAL" }),
      },
      {
        queryKey: ["reportStats", "scheduled"],
        queryFn: () => getReports({ page: 0, size: 1, status: "SCHEDULED" }),
      },
      {
        queryKey: ["reportStats", "lastGenerated"],
        queryFn: () =>
          getReports({ page: 0, size: 1, sort: "generatedOn,desc" }),
      },
    ],
  });

  const [totalQuery, awaitingQuery, scheduledQuery, lastGeneratedQuery] =
    results;

  const isLoading = results.some((r) => r.isLoading);
  const isError = results.some((r) => r.isError);

  const lastReport = lastGeneratedQuery.data?.data?.[0];

  return {
    stats: {
      totalReports: totalQuery.data?.totalCount ?? 0,
      awaitingApproval: awaitingQuery.data?.totalCount ?? 0,
      scheduled: scheduledQuery.data?.totalCount ?? 0,
      lastGeneratedOn: lastReport?.generatedOn ?? null,
      lastGeneratedBy: lastReport?.createdByName ?? null,
    },
    isLoading,
    isError,
  };
};
